import type { ModelDocument, ModelType } from '../shared/contracts.js';
export const derivationTargets: Record<ModelType, readonly ModelType[]> = {
  conceptual: ['logical', 'logical-physical'],
  logical: ['conceptual', 'logical-physical', 'physical'],
  'logical-physical': ['conceptual', 'logical', 'physical'],
  physical: ['logical', 'logical-physical'],
};
export function derivationSourceType(document: ModelDocument, representationId = document.model.activeRepresentation): ModelType {
  const kind = document.representations.find(r=>r.representationId===representationId)?.kind;
  return document.model.modelType === 'logical-physical' && (kind === 'logical' || kind === 'physical' || kind === 'logical-physical') ? 'logical-physical' : kind as ModelType;
}
export function allowedDerivationTargets(document: ModelDocument, representationId?: string) {
  return derivationTargets[derivationSourceType(document,representationId)] ?? [];
}

/** Resolve the logical perspective belonging to this physical representation, never an unrelated one. */
export function logicalPerspective(document: ModelDocument, representationId = document.model.activeRepresentation) {
  const source = document.representations.find(r=>r.representationId===representationId);
  if(source?.kind === 'logical') return source;
  const parent = document.representations.find(r=>r.representationId===source?.sourceRepresentationId && r.kind === 'logical' && !r.baseline);
  if(parent)return parent;
  const children = document.representations.filter(r=>r.kind === 'logical' && r.sourceRepresentationId===representationId && !r.baseline);
  // An explicitly active child is the user's selected perspective; otherwise newest derived child.
  return children.find(r=>r.representationId===document.model.activeRepresentation) ?? children.at(-1);
}
